<div class="card h-100 container-fuild">
  <div class="card-body p-3">

    <h2>Networks to peer with</h2>

    <table class="table border-0" style="height: 0px; overflow-y: auto; overflow-x: auto;">
      <thead>
        <tr>
          <th>Environment Name</th>
          <th>Region</th>
          <th>Servers</th>
          <th>Server Plan</th>
          <th>Operating System</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        <!-- Iterate over environments if there are any -->
        <tr *ngFor="let environment of selectedEnvironments">
          <td>{{ environment.name }} ({{ environment.type }})</td>
          <td>{{ environment.region }}</td>
          <td>
            <div *ngFor="let server of environment.servers.split(', ')" class="pb-1">
              <div class="d-flex flex-row align-items-center fa-parent">
                <div class="circle"></div>
                <span>{{ server }}</span>
              </div>
            </div>
          </td>
          <td class="pl-3">{{ environment.serverProfile }}</td>
          <td class="pl-2">{{ environment.os }}</td>
          <td>
            <button type="button" class="btn btn-danger btn-sm" (click)="deleteEnvironment(environment)">Delete</button>
          </td>
        </tr>

        <!-- if no environments are selected -->
        <tr *ngIf="selectedEnvironments.length === 0">
          <td colspan="6">
            <p>Please add at least one environment to establish a peer connection.</p>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div>
